import React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { Fonts } from "shared/constants/AppEnums";
import AppCard from "@crema/core/AppCard";
import { Link } from "react-router-dom";

const QuickLinkCard = ({ bgColor, text, href }) => {
    return (
        <AppCard
            sxStyle={{
                height: 1,
                textAlign: "center",
                backgroundColor: bgColor,
            }}
            contentStyle={{
                p: 0,
                "&:last-of-type": {
                    pb: "0 !important",
                },

                "& > a": {
                    textDecoration: "none",
                },
            }}
        >
            <Link to={href}>
                <Box
                    component="span"
                    sx={{
                        display: "block",
                        color: "common.white",
                        py: 8,
                        fontSize: 20,
                        fontWeight: Fonts.MEDIUM,
                    }}
                >
                    {text}
                </Box>
            </Link>
        </AppCard>
    );
};

export default QuickLinkCard;

QuickLinkCard.defaultProps = {
    bgColor: "",
    href: "#",
};

QuickLinkCard.propTypes = {
    text: PropTypes.any.isRequired,
    bgColor: PropTypes.string,
    href: PropTypes.string,
};
